import { DialogOpenChangeData, DialogOpenChangeEvent } from '@fluentui/react-components';
import { useState } from 'react';

export const useDialogControls = (open?: boolean, onOpenChange?: (isOpen: boolean) => void, onCloseDialog?: () => void) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const isOpenControlled = typeof open === 'boolean';
    const dialogOpen = isOpenControlled ? (open as boolean) : isOpen;
    const setDialogOpen = (nextOpen: boolean) => {
        if (!isOpenControlled) {
            setIsOpen(nextOpen);
        }

        onOpenChange?.(nextOpen);
    };
    const closeDialog = () => {
        setDialogOpen(false);
        onCloseDialog?.();
    };
    const onOpenChangeHandler = (e: DialogOpenChangeEvent, data: DialogOpenChangeData) => {
        e.stopPropagation();

        setDialogOpen(data.open);
    };

    return [dialogOpen, onOpenChangeHandler, closeDialog] as const;
};
